const HistoryIcon = () => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.4856 8C2.4856 4.41136 5.39695 1.5 8.9856 1.5C12.5742 1.5 15.4856 4.41136 15.4856 8C15.4856 11.5886 12.5742 14.5 8.9856 14.5C5.39695 14.5 2.4856 11.5886 2.4856 8ZM8.9856 2.5C5.94924 2.5 3.4856 4.96364 3.4856 8C3.4856 11.0364 5.94924 13.5 8.9856 13.5C12.022 13.5 14.4856 11.0364 14.4856 8C14.4856 4.96364 12.022 2.5 8.9856 2.5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.9856 3.5C9.26174 3.5 9.4856 3.72386 9.4856 4V8H11.9856C12.2617 8 12.4856 8.22386 12.4856 8.5C12.4856 8.77614 12.2617 9 11.9856 9H8.9856C8.70945 9 8.4856 8.77614 8.4856 8.5V4C8.4856 3.72386 8.70945 3.5 8.9856 3.5Z"
      fill="currentColor"
    />
  </svg>
)

export default HistoryIcon
